import { modifyGroups, setPrivileges, setUserData } from 'Actions/index';
import { PrivilegeBase, Id } from 'NSwag/ServerClient/Client.nswag';
import { SubscriptionTypes } from 'WebSocket/CacheManager/SubscriptionTypes';
import { BaseHandler } from 'WebSocket/Handlers/BaseHandler';
import { PermissionsData } from "NSwag/ServerClient/Client.nswag";
import { Action, Store } from 'redux';
import { IPrivileges } from 'Store/IPrivileges';

/**
 * Defines a web socket to handle async updates for
 * a logged in User's Permissions from the API.
 */
export class PermissionsHandler extends BaseHandler<PermissionsData> {
    /** @inheritdoc */
    subscriptionType: SubscriptionTypes = SubscriptionTypes.Permissions;

    /** @inheritdoc */
    type = PermissionsData;

    /**
     * The current store for this handler.
     */
    store: Store<any, Action>;

    /**
     * Creates a new Handler object
     * @param store - The CacheManager store.
     */
    constructor(store: Store<any, Action>) {
        super();
        this.store = store;
    }

    /**
     * @inheritdoc
     */
    handleAdd = (data: PermissionsData[]) => {
        // Currently not supported by the API
    }

    /**
     * @inheritdoc
     */
    handleModify = (data: PermissionsData[]) => {
        let permissionsData = data[0];
        if (permissionsData) {
            this.store.dispatch(modifyGroups(permissionsData.allGroups!));
            // This cast should be safe since all subsystem names should be lower
            // case, and the typed version of each subsystems privileges object.
            let newPrivileges = this.parsePrivileges(permissionsData.privileges!);
            this.store.dispatch(setPrivileges(newPrivileges));
            this.store.dispatch(setUserData(permissionsData.userData!));
        }
    }

    /**
     * Reads through the privileges Index Signature object
     * and returns them in a IPrivileges format.
     */
    parsePrivileges = (privileges: { [key: string]: PrivilegeBase }): IPrivileges => {
        let newPrivileges: IPrivileges = { ...this.store.getState().privileges as IPrivileges }
        Object.keys(privileges).forEach(subsystem => {
            if (newPrivileges.hasOwnProperty(subsystem)) {
                newPrivileges[subsystem] = privileges[subsystem];
            }
        });

        return newPrivileges;
    }

    /**
     * @inheritdoc
     */
    handleDelete = (data: Id[]) => {
        // Currently not supported by the API
    }
}